module.exports = __webpack_public_path__ + "img/237-netherlands.226f307f.svg";